export enum SubscriptionStatus {
  InTrial = 'in_trial',
  Cancelled = 'cancelled',
}
